import React, { FC } from 'react';

import CustomScrollbar from '../custom-scrollbar';
import Chart from './components/chart';

const Diagram: FC<any> = props => {
	const { data } = props;

	if (!data.length) return null;

	const oneBarWidth = 100;
	const chartWidth = data.length * oneBarWidth;

	return (
		<CustomScrollbar width={chartWidth}>
			<Chart {...props} chartWidth={chartWidth} />
		</CustomScrollbar>
	);
};

export default React.memo(Diagram);
